/* eslint-disable max-len */
import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { HistoryOutlined, UpdateOutlined } from '@mui/icons-material';
import { AlertBoxMsg, Divider } from '@qrios/frontend-library';

import { DialogError } from '../../../business-error';
import locales from '../../../../../constants/locales';
import { DialogActionButtons, DialogDescription } from '../../../dialog';

import { STATUS } from '../../interfaces';
import { getDialogReportStatus } from '../utils/helpers';
import { RegeneratedReport, RegeneratedReportMetaData } from './interfaces';

interface Props {
  loading: boolean;
  report: RegeneratedReport | undefined;
  error: DialogError;
  handleRegenerateReport: () => void;
  handleCloseRegenerateReport: () => void;
  filtersSummary: (filters: RegeneratedReportMetaData) => ReactNode;
}

const RegenerateReportDialog = ({
  loading,
  report,
  error,
  handleRegenerateReport,
  handleCloseRegenerateReport,
  filtersSummary
}: Props) => {
  const actions = {
    primary: {
      type: 'button' as const,
      handler: handleRegenerateReport,
      text: 'Regenerate report'
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseRegenerateReport,
      text: locales.button.title.close
    }
  };

  return report ? (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={report.status === STATUS.EXPIRED ? HistoryOutlined : UpdateOutlined}>
        You want to regenerate {getDialogReportStatus(report.status)} <b>{report.name}</b> report. It will be
        regenerated according to the filters below. The original report will remain unchanged. Click{' '}
        <b>Regenerate report</b> to confirm.
      </DialogDescription>
      <Divider orientation="horizontal" />
      <Box>{filtersSummary(report.metadata)}</Box>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} />
    </Box>
  ) : null;
};

export default RegenerateReportDialog;
